// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__JaXdP","noInteraction":"EventWrapper_noInteraction__3rG6J","pointerPassthrough":"EventWrapper_pointerPassthrough__3FQvg"};